// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3a87f500","453":"a3645d82","455":"0ba69177"}[chunkId] + ".chunk.js";
};